import DetailsList from './DetailsList';

export default DetailsList;
